import { CSSProperties } from 'react';

// eslint-disable-next-line import/prefer-default-export
export const overlayInnerStyle = {
  borderRadius: '5px',
  padding: '6px 10px 5px 10px',
  fontSize: '15px'
};

export const overlayInnerStyleTextCenter: CSSProperties = {
  borderRadius: '5px',
  padding: '5px 10px',
  fontSize: '15px',
  textAlign: 'center'
};
